import { Component } from '@angular/core';
import { BenefitBusinessAccountComponent } from "../../benefit-business-account/benefit-business-account.component";

@Component({
  selector: 'app-dialog-benefit-business-account',
  imports: [BenefitBusinessAccountComponent],
  templateUrl: './dialog-benefit-business-account.component.html',
  styleUrl: './dialog-benefit-business-account.component.scss'
})
export class DialogBenefitBusinessAccountComponent {

}
